import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

// Admin route component - only allows access to users with admin role
const AdminRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useContext(AuthContext);
  
  if (loading) return <div className="loading">Loading...</div>;
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) return <Navigate to="/login" />;
  
  // If not an admin, redirect to dashboard
  if (user && user.role !== 'admin') return <Navigate to="/" />;
  
  // Otherwise, render the children (admin component)
  return children;
};

export default AdminRoute;
